import axios from 'axios';
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function partyCreate(host) {
  try {
    const r = await axios.post(`${API}/party/create`, { host });
    return r.data;
  } catch (e) { return null; }
}
export async function partyGet(code) {
  try {
    const r = await axios.get(`${API}/party/${encodeURIComponent(code)}`);
    return r.data;
  } catch (e) { return null; }
}
export async function partyJoin(code, tag, classId) {
  try {
    const r = await axios.post(`${API}/party/${encodeURIComponent(code)}/join`, { tag, class_id: classId });
    return r.data;
  } catch (e) { return null; }
}
export async function partySetSeed(code, tag, seed, ascension = 0) {
  try {
    const r = await axios.post(`${API}/party/${encodeURIComponent(code)}/set-seed`, { tag, seed, ascension });
    return r.data;
  } catch (e) { return null; }
}
export async function partyUpdate(code, tag, score, floor, status, classId, extras = {}) {
  try {
    const body = { tag, score, floor, status, class_id: classId };
    if (extras.hp_pct !== undefined) body.hp_pct = extras.hp_pct;
    if (extras.boss_defeated !== undefined) body.boss_defeated = extras.boss_defeated;
    if (extras.avatar !== undefined) body.avatar = extras.avatar;
    const r = await axios.post(`${API}/party/${encodeURIComponent(code)}/update`, body);
    return r.data;
  } catch (e) { return null; }
}
export async function partyReset(code, host) {
  try {
    const r = await axios.post(`${API}/party/${encodeURIComponent(code)}/reset`, { host });
    return r.data;
  } catch (e) { return null; }
}
export async function partyDraftStart(code, host, pool, seed, picksPerPlayer = 10) {
  try {
    const r = await axios.post(`${API}/party/${encodeURIComponent(code)}/draft-start`, { host, pool, seed, picks_per_player: picksPerPlayer });
    return r.data;
  } catch (e) { return null; }
}
export async function partyDraftPick(code, tag, cardIdx) {
  try {
    const r = await axios.post(`${API}/party/${encodeURIComponent(code)}/draft-pick`, { tag, card_idx: cardIdx });
    return r.data;
  } catch (e) { return null; }
}
